import { Row } from '@tanstack/react-table';
import { UserSchema } from '@/features/users/schemas/users.schema.ts';
import { UsersTableRowEditAction } from '@/features/users/components/users-table/users-table-row-edit-action.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import { Button } from '@/components/ui/button.tsx';
import { DotsHorizontalIcon } from '@radix-ui/react-icons';
import { UsersTableRowPlantAccessAction } from '@/features/users/components/users-table/users-table-row-plant-access-action.tsx';
import { useSession } from '@/services/providers/session-provider.tsx';
import { useDeleteUserQuery } from '@/features/users/hooks/mutations/[user]/delete-user.tsx';

export function UsersTableRowActions<TUser>({ row }: { row: Row<TUser> }) {
  const user = UserSchema.parse(row.original);

  const allowedUsers = ['catalin.petrovici@nokto.eu'];
  const { email } = useSession();

  const canDelete = allowedUsers.includes(email);

  const { mutate: deleteUserMutation } = useDeleteUserQuery();

  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="data-[state=open]:bg-muted flex h-8 w-8 p-0 hover:bg-gray-200"
          >
            <DotsHorizontalIcon className="h-5 w-5" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="flex flex-col gap-1">
          <DropdownMenuItem asChild>
            <UsersTableRowEditAction user={user} />
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <UsersTableRowPlantAccessAction user={user} />
          </DropdownMenuItem>
          {canDelete && (
            <DropdownMenuItem
              onClick={() => {
                deleteUserMutation({ userId: user.userId });
              }}
            >
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
